import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialGroupItemCategoryState: Dtos.GroupItemCategory & IRegistrationFormState = {
    categoryId: null,
    groupItemTemplateCategory: null,
    groupItems: [],
    groupItemSummaries: [],
    saveAndReturn: null
}

export interface IGroupItemCategoryReduxFormState {
    categoryId: IFieldState<number>,
    category: IFieldState<Dtos.GroupItemCategory>,
    groupItems: IFieldState<Dtos.GroupItem[]>,
    groupItemSummaries: IFieldState<Dtos.GroupItemSummary[]>
}
